import {Component, OnInit, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Model_Datasource, Model_WorkflowComponent, Model_VariableEnvironnement, TYPE_DEFAULT_VALUE } from 'src/app/app.models';
import { FormBuilder } from '@angular/forms';

@Component({
    selector: 'app-datasource-parameters-dialog',
    templateUrl: './datasource-parameters-dialog.component.html',
    styleUrls: ['./datasource-parameters-dialog.component.scss']
})
export class DatasourceParametersDialogComponent implements OnInit {
    datasource: any;
    workflowComponents: Model_WorkflowComponent[] = [];
    gridComponents: Model_WorkflowComponent[] = [];
    variables: Model_VariableEnvironnement[] = [];
    formGroup = this._formBuilder.group({
        DS_PARAMETERS: [null]
    });

    constructor(
        private _formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<DatasourceParametersDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { datasource: any, workflowComponents: Model_WorkflowComponent[], gridComponents?: Model_WorkflowComponent[], variables: Model_VariableEnvironnement[] },
    ) {
        this.datasource = data.datasource;
        this.workflowComponents = data.workflowComponents;
        this.gridComponents = data.gridComponents;
        this.variables = data.variables;
        if (!!this.datasource && !!this.datasource.DS_PARAMETERS) {
            this.formGroup.controls.DS_PARAMETERS.patchValue(this.datasource.DS_PARAMETERS);
        }
    }

    ngOnInit() {
    }

    dismiss() {
        this.dialogRef.close();
    }

    onSubmit() {
        const formValues = this.formGroup.value;
        this.dialogRef.close(formValues.DS_PARAMETERS);
    }
}